'use client';

import { Stack } from '@mui/material';
import CtaButton from '../../../../elements/ctaButton';
import { FormType, StepConfig } from '../../type';
import { useTranslate } from '@jd/i18n';

type Props = {
  currentStep: number;
  totalSteps: number;
  formType: FormType;
  stepConfig: StepConfig;
  submitButtonLabel?: string;
  isSubmitting: boolean;
  onBack: () => void;
};

const StepNavigation = ({
  currentStep,
  totalSteps,
  formType,
  stepConfig,
  submitButtonLabel,
  isSubmitting,
  onBack,
}: Props) => {
  const common_t = useTranslate('common');
  const isLastStep = currentStep === totalSteps - 1;
  const showBack = formType === 'multiSaveAfter' && currentStep > 0;

  return (
    <Stack direction="row" spacing={2}>
      {showBack && (
        <CtaButton variant="outlined" onClick={onBack} disabled={isSubmitting}>
          {common_t('previous')}
        </CtaButton>
      )}
      <CtaButton
        variant="contained"
        type="submit"
        disabled={isSubmitting}
        loading={isSubmitting}
        loadingPosition="start"
      >
        {isLastStep
          ? (submitButtonLabel || common_t('submit'))
          : (stepConfig.nextButtonLabel || common_t('next'))}
      </CtaButton>
    </Stack>
  );
};

export default StepNavigation;
